import { useVuex } from '@issue-detail/utils/useVuex';
import { computed } from '@vue/composition-api';

export const useShare = () => {
  const vuex = useVuex();
  const roles = computed<Array<{ roleCode: string }>>(
    () => vuex.state.user.roles || []
  );
  const enterPreviewMode = computed<boolean>(
    () => vuex.state.user.enterPreviewMode
  );
  const isVisitor = computed(() =>
    roles.value.some(r => r.roleCode === 'anonymous') || enterPreviewMode.value
  );
  const shareInfo = computed(() => vuex.state.user.shareInfo);

  return {
    isVisitor,
    shareInfo,
    shareProjectId: computed<number | undefined>(() => shareInfo.value.projectId)
  };
};

export type ShareStore = ReturnType<typeof useShare>;
